import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { session_id });
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const target = data.role === "super_admin" ? "/admin/super" : "/admin";
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(target, { replace: true, state: { user: data } });
      } catch {
        navigate("/login?error=oauth", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#2A2626] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-[#5C5856]" data-testid="auth-callback-loading">Signing you in…</p>
      </div>
    </div>
  );
}
